import type { NotificationOverviewSummaryRecord } from '@navio/nsdk';
import { NoddiButton, NoddiInfoBanner } from 'noddi-ui-web';
import type { NotificationGroupOverviewTranslations } from './notificationTranslations';

type Props = {
  summary: NotificationOverviewSummaryRecord;
  showOnlyNeedsAttention: boolean;
  translations: NotificationGroupOverviewTranslations;
  onShowCars: () => void;
};

/** Warning above the tabs when cars have no driver, or a driver who gets no SMS. */
export const CarsNeedingAttentionBanner = ({ summary, showOnlyNeedsAttention, translations: t, onShowCars }: Props) => {
  if (summary.carsWithoutManagerCount === 0 && summary.carsWithSilencedManagerCount === 0) {
    return null;
  }

  return (
    <NoddiInfoBanner
      variant='warning'
      actionNode={
        !showOnlyNeedsAttention && (
          <NoddiButton variant='outline' size='small' startIcon='Car' onClick={onShowCars}>
            {t.showCarsNeedingDriver}
          </NoddiButton>
        )
      }
      texts={[
        ...(summary.carsWithoutManagerCount > 0
          ? [
              {
                key: t.carsWithoutDriver(summary.carsWithoutManagerCount),
                value: t.carsWithoutDriverDescription
              }
            ]
          : []),
        ...(summary.carsWithSilencedManagerCount > 0
          ? [
              {
                key: t.carsWithSilencedDriver(summary.carsWithSilencedManagerCount),
                value: t.carsWithSilencedDriverDescription
              }
            ]
          : [])
      ]}
    />
  );
};
